export const INTERVIEW_HEADER_TYPE = 'INTERVIEW_HEADER_TYPE';

export const NO_OPTIONS_HEADER_TYPE = 'NO_OPTIONS_HEADER_TYPE';
